import t_08_2302 from './KZ.T.08.2302.svg'
import t_08_2302_b from './KZ.T.08.2302 black.svg'

export default [
  t_08_2302,
  t_08_2302_b,
]
